import getCompanyAssociatedTags from '../../../actions/api/tag/getCompanyAssociatedTags';
import {
  SUCCESS_API_GET_COMPANY_TAG_SET,
  // SET_TAGS_FOR_LEVEL,
} from '../../../actions/actionTypes';

/**
 * 指定された階層までのタグをAPIから取得し、Redux ストアにセットする関数。
 *
 * @param {string} apiToken - APIリクエストのための認証トークン。
 * @param {number} maxDepth - 取得するタグの最大階層。
 * @param {boolean} showUnavailableTags - 利用不可のタグをレスポンスに含めるかどうかを指定する。
 *                                        trueの場合、利用不可のタグも含めて取得する。falseの場合は、利用可能なタグのみを取得する。
 * @returns {Function} Reduxのdispatch関数。取得したタグをストアにセットするアクションを実行する。
 */
const getAllTagsUpToLevel =
  (apiToken, selectedTagIds, selectedTagSetId, maxDepth) => dispatch => {
    // eslint-disable-next-line no-eq-null
    let validTagCount = selectedTagIds.filter(id => id != null).length;
    if (selectedTagIds.length < maxDepth) {
      validTagCount += 1;
    }

    for (
      let currentDepth = 0;
      currentDepth <= validTagCount;
      currentDepth += 1
    ) {
      const actionType =
        currentDepth === 0
          ? SUCCESS_API_GET_COMPANY_TAG_SET
          : 'GET_UPDATE_TAGS';
      let parentId;

      if (currentDepth === 0) {
        parentId = null;
      } else if (currentDepth === 1) {
        parentId = selectedTagSetId;
      } else {
        parentId = selectedTagIds[currentDepth - 2];
      }

      dispatch(
        getCompanyAssociatedTags(
          apiToken,
          {
            depth: currentDepth,
            isDeleted: false,
            isUsable: null,
            parentId,
          },
          actionType,
        ),
      );
    }
  };

export default getAllTagsUpToLevel;
